<div fxLayout="column" fxFlexFill>
  <div class="scrolled" fxLayout="column" fxFlex>

    <div class="flex flex-col p-4" *ngIf="currMerchant != null">

      <div class="relative w-full h-40 sm:h-64 bg-cover bg-center rounded-xl"
           [ngStyle]="{ 'background-image': 'url(' + getBanner + ')' }">

      </div>

      <div
        class="mx-4 my-6"
        class="text-lg sm:text-2xl text-gray-800 uppercase font-bold fontPoppins">
        {{currMerchant.denomination | uppercase | descFilter: 30}}
      </div>

      <!-- Statistiques -->
      <div class="flex flex-col sm:flex-row justify-around items-center bg-white shadow-md rounded-lg p-4 gap-4 ">
        <!-- Points fidélité -->
        <div class="flex flex-1 flex-col items-center">
        <span
          class="text-xl font-bold text-indigo-600">{{(merchantClient.fidelity_points_clients_dash ? merchantClient.fidelity_points_clients_dash : 0)| number: '1.2-2'}}</span>
          <span class="text-sm text-gray-500">Points Fidélité</span>
        </div>

        <!-- Cagnotte fidélité -->
        <div class="flex flex-1 flex-col items-center">
        <span
          class="text-xl font-bold text-green-600">{{(merchantClient.credit_fidelity_amount_clients_dash ? merchantClient.credit_fidelity_amount_clients_dash : 0) |
          priceFilter}}</span>
          <span class="text-sm text-gray-500">Cagnotte Fidélité</span>
        </div>

        <!-- Cagnotte euros -->
        <div class="flex flex-1 flex-col items-center">
        <span
          class="text-xl font-bold text-amber-600">{{(merchantClient.credit_amount ? merchantClient.credit_amount : 0)
          | priceFilter}}</span>
          <span class="text-sm text-gray-500">Cashless</span>
        </div>
      </div>

      <div
        class="mx-4 my-6"
        [ngClass]="cssService.itemListTitleClass">
        <span>Vos opérations et services</span>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">

        <ng-container *ngFor="let card of actionCards">
          <div
            *ngIf="card.condition === undefined || card.condition"
            (click)="card.clickAction()"
            class="bg-white shadow-md rounded-lg p-4 flex flex-col items-center hover:shadow-lg transition cursor-pointer">
            <i [class]="card.icon + ' ' + card.iconColor + ' text-3xl mb-2'"></i>
            <h3 class="text-lg font-semibold text-gray-800">{{ card.title }}</h3>
            <div *ngIf="card.blocked" class="text-sm  font-semibold text-red-700">{{ "cashlessOptionComponent.blockedCard" | translate }}</div>
            <p *ngIf="!card.blocked" class="text-sm text-gray-500 text-center">{{ card.description }}</p>

          </div>
        </ng-container>
      </div>

      <div *ngIf="checkMerchantOptions(13)">

        <div
          class="mx-4 my-6"
          [ngClass]="cssService.itemListTitleClass">
          <span>Ma fidelité</span>
        </div>

        <div>

          <div *ngIf="getOffers != null">

            <div *ngIf="getOffers.length > 0" class="grid grid-cols-1 lg:grid-cols-2 gap-2">

              <div *ngFor="let offer of getOffers" class="bg-white shadow-md rounded-lg p-4 w-full ">
                <!-- Header -->
                <div class="flex items-center justify-between mb-4">
                  <h3 class="text-md font-semibold text-gray-800">{{offer.fidelity_rule.name | capitalize}}</h3>
                  <span class="text-sm text-gray-500 font-semibold">{{offer.ongoing_value}}
                    / {{offer.fidelity_rule.input_value}}</span>
                </div>

                <!-- Progress Bar -->
                <div class="w-full bg-gray-200 rounded-full h-3 mb-4 overflow-hidden">
                  <div class="bg-indigo-600 h-3 rounded-full" [style.width.%]="offer.percent"></div>
                </div>

                <!-- État -->
                <div class="">
                  <span class="text-sm text-gray-500">{{offer.fidelity_rule.description}}</span>
                </div>

              </div>

            </div>

            <div *ngIf="getOffers.length == 0">
              <div class="flex items-center justify-center w-full h-20 border-2 border-dashed border-gray-300 bg-white bg-opacity-50 rounded-lg bg-transparent">
                <span class="text-gray-400 text-sm">Aucune offre en cours</span>
              </div>
            </div>

          </div>

          <!-- Produits que l'on peut avoir -->
          <app-fidelity-slider-product
            [merchant]="currMerchant"
            [client]="merchantClient"
            [available]="true">
          </app-fidelity-slider-product>

          <!-- Produits que l'on peut bientot avoir -->
          <app-fidelity-slider-product
            [merchant]="currMerchant"
            [client]="merchantClient"
            [available]="false">
          </app-fidelity-slider-product>

        </div>

      </div>

    </div>

  </div>
</div>
